import React, { ReactElement } from 'react'
import Icon from '@dustin-web/microsite-components/src/icon'
import { useResponsive } from '@dustin-web/microsite-components/src/hooks'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import Tooltip from '@dustin-web/microsite-components/src/tooltip'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import type { RelatedCategoriesQuery } from '@dustin-web/microsite-baselayout/src/components/header/types'
import { cleanCategoryNamePath } from '@dustin-web/microsite-baselayout/src/components/header/utils'

type Props = {
  searchPhrase: string
  relatedCategories: RelatedCategoriesQuery
  header: ReactElement
}

const RelatedCategories = ({ searchPhrase, relatedCategories, header }: Props) => {
  const { translate } = useTranslations()
  const { isSmallScreen } = useResponsive()

  return (
    <>
      {header}
      <ul className="c-header__autocomplete-mini-list">
        {relatedCategories?.map((category, i) => (
          <li key={i} className="c-header__autocomplete-mini-item">
            <Tooltip
              layer="header"
              disable={isSmallScreen}
              className="d-block"
              tooltipText={cleanCategoryNamePath(category.category?.namePath ?? '')}>
              <a
                className="c-header__autocomplete-mini-link"
                href={`/${translate('SearchPath')}/${searchPhrase}/${category.category?.pathSlug ?? ''
                  }`}
                onClick={() =>
                  DigitalData.pushSearchDropdownInteraction(
                    category?.category?.name ?? '',
                    searchPhrase,
                    'search_within'
                  )
                }>
                <Icon className="c-header__autocomplete-mini-icon" name="gallery" />
                <span className="c-header__autocomplete-mini-text">
                  <span>{category.category?.name}</span>
                  <span className="c-header__autocomplete-mini-category">
                    {translate('Category')}
                  </span>
                </span>
                <span>{category.count}</span>
              </a>
            </Tooltip>
          </li>
        ))}
      </ul>
    </>
  )
}

export default RelatedCategories
